module.exports = __webpack_public_path__ + "img/btn-default.407e0291.png";